<ng-container *ngIf="state?.enabled">
  <div class="duesy-launchers" [class.duesy-launchers--panel-open]="state.panel === 'open'">
    <button
      type="button"
      class="duesy-help-button"
      aria-label="Help menu"
      aria-haspopup="menu"
      (click)="helpMenu.toggle($event)"
    >
      <span aria-hidden="true">?</span>
    </button>
    <button
      #fab
      type="button"
      class="duesy-fab"
      aria-controls="duesy-panel"
      [attr.aria-expanded]="state.panel === 'open'"
      [attr.aria-label]="state.panel === 'open' ? 'Minimize Duesy' : 'Open Duesy, your duesPlus support assistant'"
      (click)="toggle()"
    >
      <app-duesy-robot-icon></app-duesy-robot-icon>
      <span *ngIf="state.firstVisit" class="duesy-fab__badge" aria-hidden="true">1</span>
    </button>
  </div>

  <p-menu #helpMenu [popup]="true" [model]="helpItems" appendTo="body" styleClass="duesy-help-menu"></p-menu>

  <app-duesy-panel
    *ngIf="state.panel === 'open'"
    (minimizeRequest)="minimize()"
    (closeRequest)="close()"
  ></app-duesy-panel>
</ng-container>
